import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { EquipmentModel } from "src/app/equipment/equipment";
import { AuthService } from "src/app/auth.service";

@Injectable({
  providedIn: "root",
})
export class EquipmentService {
  private baseURL = environment.baseUrl;
  constructor(private http: HttpClient, private auth: AuthService) { }

  /**
   * Get Equipment List
   * @returns
   */
  getEquipmentList() {
    return this.http.get(`${this.baseURL}/rhAPI/getEquipments/${this.auth.getContractorInfo().contractor_id}`);
  }

  /**
   * Get One Equipment
   * @returns
   */
  getSingleEquipment(equipmentId: String | number) {
    return this.http.get(
      `${this.baseURL}/rhAPI/getOneEquipment/${equipmentId}`
    );
  }

  /**
   * Delete Equipment
   * @param equipmentId
   * @returns
   */
  deleteEquipment(equipmentId: String | number) {
    return this.http.post(
      `${this.baseURL}/rhAPI/delete_equipment/${equipmentId}`,{}
    );
  }

  /**
   * Add New Equipment
   * @param equipment
   * @returns
   */
  addNewEquipment(equipment: EquipmentModel) {
    return this.http.post(`${this.baseURL}/rhAPI/addEquipment/${this.auth.getContractorInfo().contractor_id}`, equipment);
  }

  /**
   * Update Exisitng Equipment
   * @param equipment
   * @returns
   */
  updateExisitngEquipment(equipment: EquipmentModel) {
    return this.http.post(
      `${this.baseURL}/rhAPI/editEquipment/${equipment.equipment_id}`,
      equipment
    );
  }

  /**
   * Get Seasons
   * @returns
   */
  getSeasons() {
    return this.http.get(this.baseURL + `/rhAPI/getseasons`);
  }
}
